<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-printer-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{titlemodal}}</h4>
                            <p class="cf-modal-head__sub">Aperçu avant impression</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">



                    <div class="box  overflow-hidden">
                        <div class="box-header justify-between">
                            <div class="box-title">
                                {{titlemodal}}
                            </div>


                        </div>


                        <div class="box-body !p-0">

                            <div class="grid lg:grid-cols-2 gap-6">


                                <div class="space-y-2">
                                    <label class="ti-form-label dark:text-defaulttextcolor/70 mb-0">Impression en</label>
                                    <select v-model="taillemodel" class="form-control mb-3">
                                        <option value="A4">A4</option>
                                        <option value="A4landscape">A4 landscape</option>
                                        <!--option value="A5">A5</option>
                                        <option value="A5landscape">A5 landscape</option-->
                                    </select>
                                </div>


                                <div  class="space-y-2">
                                    <div class="w-full flex grid-cols-2">

                                        <div class="box-title mb-2 sm:mb-0"></div>

                                        <div class="inline-flex rounded-md shadow-sm w-full" role="group" aria-label="Basic example">

                                            <div class="grid lg:grid-cols-2 gap-6 w-full">
                                                <div class="space-y-2">
                                                    <label >&nbsp;&nbsp;</label>
                                                    <input class="w-full" type="date"  @change="refresh" v-model="datedebut" placeholder="Date début">
                                                </div>

                                                <!--div class="space-y-2">
                                                    <label >&nbsp;&nbsp;</label>
                                                    <input class="w-full" type="date" @change="refresh" v-model="datefin" placeholder="Date fin">
                                                </div-->
                                            </div>


                                        </div>
                                    </div>


                                </div>



                            </div>


                            <div class="grid lg:grid-cols-2 gap-6 mt-4">

                                <div class="space-y-2">
                                    <button @click="print4" class="ti-btn ti-btn-success-full w-full"> Imprimer</button>


                                </div>

                                <!--div class="space-y-2">
                                    <button    @click="ExportExcel('xlsx',`${titlemodal} période (${datedebut} - ${datefin})`)"
                                               class="ti-btn ti-btn-danger-full  w-full"> Excel</button>
                                </div-->


                            </div>




                            <div class="table-responsive mybodyheight300px">
                                <div ref="printdoc" class="p-5 print-container">
                                    <div class="max-w-6xl mx-auto bg-white p-6 ">

                                        <div class="header header-print border-b-2 border-gray-300 pb-2 mb-3 no-break">


                                            <div class="flex justify-between items-center mb-6 no-break">
                                                <div>
                                                    <img
                                                            v-if="$store.state.etatlogo"
                                                            :src="$store.state.etatlogo"
                                                            alt="Logo gauche"
                                                            class="w-24 h-auto object-contain"
                                                    />
                                                </div>
                                                <!--div class="text-center">
                                                    <h1 class="text-2xl font-bold text-dark">RAPPORT FINANCIER</h1>
                                                    <p class="text-secondary text-sm mt-1">{{ soustitre }}</p>
                                                </div-->
                                                <div>
                                                    <img
                                                            v-if="$store.state.etatlogo"
                                                            :src="$store.state.etatlogo"
                                                            alt="Logo droite"
                                                            class="w-24 h-auto object-contain"
                                                    />
                                                </div>
                                            </div>


                                            <div class="grid grid-cols-2 gap-6 no-break">


                                                <div>
                                                    <table style="width: 100%" class=" border border-gray-300">
                                                        <tbody>
                                                        <tr>
                                                            <td class="border px-2 py-1 text-sm">
                                                                Raison Social : {{$store.state.etatraisonsocial}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="border px-2 py-1 text-sm">
                                                                IFU : {{$store.state.etatifu}} / RC N° RCCM : {{$store.state.etatrccm}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="border px-2 py-1 text-sm">
                                                                Téléphone : {{$store.state.etattelephone}} / {{$store.state.etatadresse}}
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>


                                                <div>
                                                    <table style="width: 100%" class=" border border-gray-300 text-center">
                                                        <tbody>
                                                        <tr>
                                                            <td colspan="2" class="border px-2 py-1 font-semibold text-sm">
                                                                {{ soustitre }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="border px-2 py-1 text-sm" v-if="viewperiode">PERIODE</td>
                                                            <td class="border px-2 py-1 text-sm" v-else>JOURNÉE DU</td>
                                                            <td class="border px-2 py-1 text-sm">IMPRIMÉ PAR</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="border px-2 py-1 text-sm" v-if="viewperiode">
                                                                {{ datedebut + ' - ' + datefin }}
                                                            </td>
                                                            <td class="border px-2 py-1 text-sm" v-else>
                                                                {{ datejournee }}
                                                            </td>
                                                            <td class="border px-2 py-1 text-sm">
                                                                {{$store.state.appusername}}
                                                            </td>
                                                        </tr>
                                                        <tr v-if="!viewperiode">
                                                            <td colspan="2" class="border px-2 py-1 text-sm">
                                                                PERIODE {{ datedebut + ' - ' + datefin }}
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </div>

                                        <!------------------------ content------------------------------>
                                            <div class="content-print">
                                        <div class="clearfix"></div>


                                        <div class="mb-4 hidden">
                                            <h2 class="text-sm font-semibold mb-4 border-b pb-2">Etat caisse</h2>
                                            <div class="grid grid-cols-6 gap-4">
                                                <div
                                                        v-for="item in summary"
                                                        :key="item.label"
                                                        class="bg-gray-50 p-4 rounded border"
                                                >
                                                    <p class="font-medium text-sm">{{ item.label }}:</p>
                                                    <p class="text-sm font-bold" :class="item.color">
                                                        {{ item.value }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- CA journalier -->
                                        <div class="mb-4" >
                                            <h2 class="text-sm font-semibold mb-4 border-b pb-2">CA journaliers</h2>
                                            <table class="min-w-full border-collapse border border-gray-300">
                                                <thead>
                                                <tr class="bg-gray-100">
                                                    <th class="border px-4 py-2 text-center text-sm">Caisse</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Date</th>
                                                    <th class="border px-4 py-2 text-center text-sm">CA</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Remise</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr
                                                        v-for="(ca, i) in datatable?.cajrs"
                                                        :key="i"
                                                        :class="i % 2 === 1 ? 'bg-gray-50' : ''"
                                                >
                                                    <td class="border px-4 py-2 text-sm">{{ ca.nomcaisse }}</td>
                                                    <td class="border px-4 py-2 text-sm">{{ ca.dateop }}</td>
                                                    <td class="border px-4 py-2 text-center text-sm">{{ formatMoney(ca.montanttotal) }}</td>
                                                    <td class="border px-4 py-2 text-center text-sm">{{ formatMoney(ca.remisetotal) }}</td>
                                                </tr>

                                                </tbody>
                                                <tfoot>
                                                <tr class="bg-gray-200 font-semibold">
                                                    <td class="border px-4 py-2 text-right text-sm" colspan="2">Total</td>
                                                    <td class="border px-4 py-2 text-center text-sm">{{formatMoney(sommeArray(datatable?.cajrs,'montanttotal'))}}</td>
                                                    <td class="border px-4 py-2 text-center text-sm">{{formatMoney(sommeArray(datatable?.cajrs,'remisetotal'))}}</td>
                                                </tr>
                                                </tfoot>
                                            </table>
                                        </div>

                                        <!-- Tableau des produits vendus -->
                                        <div class="mb-4">
                                            <h2 class="text-sm font-semibold mb-4 border-b pb-2 ">Détail des Articles Vendus</h2>
                                            <table class="min-w-full border-collapse border border-gray-300">
                                                <thead>
                                                <tr class="bg-gray-100">
                                                    <th class="border px-4 py-2 text-center text-sm">Caisse</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Article</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Qte</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Pu</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Remise</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Montant</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Pa</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Montant coût</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Marge</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr
                                                        v-for="(product, i) in datatable?.caarticle"
                                                        :key="i"
                                                        :class="i % 2 === 1 ? 'bg-gray-50' : ''"
                                                >
                                                    <td class="border px-4 py-2 text-sm">{{ product.nomcaisse }}</td>
                                                    <td class="border px-4 py-2 text-sm">{{ product.article }}</td>
                                                    <td class="border px-4 py-2 text-sm text-center">{{ formatMonney(product.qte) }}</td>
                                                    <td class="border px-4 py-2 text-sm text-center">{{ formatMoney(product.pu) }}</td>
                                                    <td class="border px-4 py-2 text-sm text-center">{{ formatMoney(product.remisetotal)}}</td>
                                                    <td class="border px-4 py-2 text-sm text-center">{{ formatMoney(product?.montanttotal) }}</td>
                                                    <td class="border px-4 py-2 text-sm text-center">{{ formatMoney(product.pa)}}</td>
                                                    <td class="border px-4 py-2 text-sm text-center">{{ formatMoney(product.pacout) }}</td>
                                                    <td class="border px-4 py-2 text-sm text-center text-green-600">{{ formatMoney(product.marge) }}</td>

                                                </tr>
                                                </tbody>
                                                <tfoot>
                                                <tr class="bg-gray-200 font-semibold">
                                                    <td class="border px-4 py-2 text-right text-sm" colspan="5">Total</td>
                                                    <td class="border px-4 py-2 text-center text-sm"> {{formatMoney(sommeArray(datatable?.caarticle,'montanttotal'))}} </td>
                                                       <td class="border px-4 py-2 text-right text-sm" >-</td>
                                                    <td class="border px-4 py-2 text-center text-sm"> {{formatMoney(sommeArray(datatable?.caarticle,'pacout'))}} </td>
                                                    <td class="border px-4 py-2 text-center text-sm"> {{formatMoney(sommeArray(datatable?.caarticle,'marge'))}} </td>
                                                </tr>
                                                </tfoot>
                                            </table>
                                        </div>

                                        <!-- Ventes par serveurs -->
                                        <div class="mb-4" v-if="datatable?.caserveur">
                                            <h2 class="font-semibold mb-4 border-b pb-2 text-sm">Ventes par Serveur</h2>
                                            <table class="min-w-full border-collapse border border-gray-300">
                                                <thead>
                                                <tr class="bg-gray-100">
                                                    <th class="border px-4 py-2 text-center text-sm">Caisse</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Date</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Serveur</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Nombre de ventes</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Remise</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Montant total</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Montant restant</th>
                                                    <th class="border px-4 py-2 text-center text-sm">Pourcentage</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr
                                                        v-for="(s, i) in datatable?.caserveur"
                                                        :key="i"
                                                        :class="i % 2 === 1 ? 'bg-gray-50' : ''"
                                                >
                                                    <td class="border px-4 py-2 text-sm">{{ s.nomcaisse }}</td>
                                                    <td class="border px-4 py-2 text-sm">{{ s.dateop }}</td>
                                                    <td class="border px-4 py-2 text-sm">{{ s.collaborateur }}</td>
                                                    <td class="border px-4 py-2 text-sm text-center">{{s.nbventes }}</td>
                                                    <td class="border px-4 py-2 text-sm text-center">{{ formatMoney(s.mtntremise) }}</td>
                                                    <td class="border px-4 py-2 text-sm text-center">{{ formatMoney(s.montanttotal) }}</td>
                                                    <td class="border px-4 py-2 text-sm text-center">{{ formatMoney(s.montanttotalrestant) }}</td>
                                                    <td class="border px-4 py-2 text-sm text-center">{{ s.pourcentage }}</td>
                                                </tr>
                                                </tbody>
                                                <tfoot>
                                                <tr class="bg-gray-200 font-semibold">
                                                    <td colspan="4" class="border px-4 py-2 text-right">Total</td>
                                                    <td class="border px-4 py-2 text-sm text-center">{{formatMoney(sommeArray(datatable?.caserveur,'mtntremise'))}}</td>
                                                    <td class="border px-4 py-2 text-sm text-center">{{formatMoney(sommeArray(datatable?.caserveur,'montanttotal'))}}</td>
                                                    <td class="border px-4 py-2 text-sm text-center">{{formatMoney(sommeArray(datatable?.caserveur,'montanttotalrestant'))}}</td>
                                                    <td class="border px-4 py-2 text-sm text-center">100%</td>
                                                </tr>
                                                </tfoot>
                                            </table>
                                        </div>

                                                <!-- Tableau des stocks -->
                                                <div class="mb-4">
                                                    <h2 class="text-sm font-semibold mb-4 border-b pb-2 ">Etat sotck des Articles Vendus(Stock)</h2>
                                                    <table class="min-w-full border-collapse border border-gray-300">
                                                        <thead>
                                                        <tr class="bg-gray-100">
                                                            <th class="border px-4 py-2 text-center text-sm">Caisse</th>
                                                            <th class="border px-4 py-2 text-center text-sm">Entrpôt</th>
                                                            <th class="border px-4 py-2 text-center text-sm">Article</th>
                                                            <th class="border px-4 py-2 text-center text-sm">Stock initial</th>
                                                            <th class="border px-4 py-2 text-center text-sm">Entree</th>
                                                            <th class="border px-4 py-2 text-center text-sm">Sortie</th>
                                                            <th class="border px-4 py-2 text-center text-sm">Transfert(Entree-Sortie)</th>
                                                            <th class="border px-4 py-2 text-center text-sm">Vente</th>
                                                            <th class="border px-4 py-2 text-center text-sm">Stock restant</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr
                                                                v-for="(product, i) in datatable?.etatstock"
                                                                :key="i"
                                                                :class="i % 2 === 1 ? 'bg-gray-50' : ''"
                                                        >
                                                            <td class="border px-4 py-2 text-sm">{{ product.caisse }}</td>
                                                            <td class="border px-4 py-2 text-sm">{{ product.magasin }}</td>
                                                            <td class="border px-4 py-2 text-sm">{{ product.article }}</td>
                                                            <td class="border px-4 py-2 text-sm text-center">{{ formatnumber(product.stockInitial) }}</td>
                                                            <td class="border px-4 py-2 text-sm text-center">{{ formatnumber(product.entrees) }}</td>
                                                            <td class="border px-4 py-2 text-sm text-center">{{ formatnumber(product.sorties)}}</td>
                                                            <td class="border px-4 py-2 text-sm text-center">{{ formatnumber(product?.transfertmtme)+' - '+formatnumber(product?.transfertmtms) }}</td>
                                                            <td class="border px-4 py-2 text-sm text-center">{{ formatnumber(product.vendu)}}</td>
                                                            <td class="border px-4 py-2 text-sm text-center">{{ formatnumber(product.stockRestantcalculersurvente) }}</td>

                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>


                                            </div>

                                        <!------------------------ fin content------------------------------>
                                        <div class="clearfix"></div>
                                        <div class="footer footer-print border-t-2 border-gray-300 pt-4 mt-6 no-break">
                                            <div class="flex justify-between">
                                                <div>
                                                    <p class="text-sm text-gray-600">Généré le: {{generationDate}} fin de rapport</p>
                                                </div>
                                                <div class="text-right">
                                                    <p class="text-sm text-gray-600">-</p>
                                                    <p class="text-sm text-gray-600">
                                                        Signature: _________________________
                                                    </p>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>





                            </div>


                        </div>



                    </div>






                </div>
                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="print4" type="button" class="ti-btn ti-btn-primary-full"><i class="ri-printer-line align-middle"></i> Imprimer</button>
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>
</template>

<script>

    import {
        currencyFormatDE, currencyFormatMonney,
        currentDate,
        currentDateTime,
        ExportExcel, FormatNumber,
        getYear, groupByKey,
        impression, issetArray, isValidDateString, NumbertoLettre,
        randomString
    } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";


    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },
            searchtrierletableau: function(newvalue,oldvalue){

                this.page=1

            }

        },
        computed:{

            soustitre(){
                this.taillemodel='A4';  return this.titlemodal
            },
            viewall(){
                if (this.mmois==="" || this.manne===""){

                    return true

                }
                else{

                    return false

                }


            },

            generationDate() {
                return currentDateTime()
            },


            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                let mvalue=this.datatable,$dataretun=[];

                if(this.isNormalisationEtat===true){

                    let t=this;

                    mvalue = mvalue.filter( function (post) {

                        return  parseFloat(post.normalise)===1

                    })

                }

                //this.page=this.Defaultpage;
                this.perPage=this.DefaultperPage;

                if (this.searchnomcaisse!==''){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {

                        return   post.nomcaisse.toLowerCase().includes(t.searchnomcaisse.toLowerCase())

                    })

                }

                if (this.searchbeneficiaire!==''){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {

                        return   post.client.toLowerCase().includes(t.searchbeneficiaire.toLowerCase())

                    })

                }

                if (this.selectedaffichage===''){

                    this.montanttolal=0
                    this.montanttolalremise=0
                    this.montanttolalrestant=0

                    let t=this
                    mvalue.forEach(function (item) {
                        t.montanttolal=parseFloat(t.montanttolal)+parseFloat(item.mtntttc)
                        t.montanttolalrestant=parseFloat(t.montanttolalrestant)+parseFloat(item.mtntttctrt)
                        t.montanttolalremise=parseFloat(t.montanttolalremise)+parseFloat(item.mtntremise)

                    })

                    $dataretun=mvalue

                }
                else {

                    this.montanttolalgroupby=0
                    this.montanttolalgroupbyremise=0
                    this.montanttolalgroupbyrestant=0

                    let t=this
                    mvalue.forEach(function (item) {
                        t.montanttolalgroupby=parseFloat(t.montanttolalgroupby)+parseFloat(item.mtntttc)
                        t.montanttolalgroupbyrestant=parseFloat(t.montanttolalgroupbyrestant)+parseFloat(item.mtntttctrt)
                        t.montanttolalgroupbyremise=parseFloat(t.montanttolalgroupbyremise)+parseFloat(item.mtntremise)

                    })

                    let $datagroupby=groupByKey(mvalue,'client')


                    for (let [index, $line] of Object.entries($datagroupby)) {


                        let t=this,montanttolal=0,montanttolalremise=0,montanttolalrestant=0
                        $line.forEach(function (item) {
                            montanttolal=parseFloat(montanttolal)+parseFloat(item.mtntttc)
                            montanttolalremise=parseFloat(montanttolalremise)+parseFloat(item.mtntremise)
                            montanttolalrestant=parseFloat(montanttolalrestant)+parseFloat(item.mtntttctrt)

                        })

                        $line.forEach(function (item) {
                            item.montanttolal=montanttolal
                            item.montanttolalremise=montanttolalremise
                            item.montanttolalrestant=montanttolalrestant

                        })

                        //$line.montanttolal=montanttolal

                    }


                    $dataretun=$datagroupby

                }

                return $dataretun;


            },


        },
        components: {


        },

        data() {
            return {

                summary: [
                    {label:"Solde d'ouverture",value:700000},
                    {label:"Total des ventes",value:2000000},
                    {label:"Total des transferts",value:2000000},
                    {label:"Bénéfice total",value:550000},
                    {label:"Factures impayées",value:0},
                    {label:"Recette nette",value:100000},
                ],

                mfontsize:10,
                taillemodel:'A4',
                mgetyear:getYear(),
                datenow:currentDate(),
                isdisplay:false,
                viewperiode:false,
                titlemodal:"",
                datatable:[],
                viewdrop:false,
                tabvalue:{},
                selectedaffichage:'',
                datejournee:"",
                datedebut:"",
                numpidcaisse:"",
                datefin:"",
                searchnomcaisse:"",
                searchbeneficiaire:"",
                typedoc:"",
                isNormalisationEtat:false,


                montanttolal:0,
                montanttolalrestant:0,
                montanttolalremise:0,
                montanttolalgroupbyremise:0,
                montanttolalgroupby:0,
                montanttolalgroupbyrestant:0,


                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 1,
                Defaultpage: 1,
                DefaultperPage: 1,
                pages: [],

                textToEncode: '',  // Initial text to encode in QR code
                size: 100,              // Size of the QR code
                level: 'L'              // Error correction level ('L', 'M', 'Q', 'H')
            };
        },
        methods: {


            sommeArray(array, key) {

                array=issetArray(array)?array:[];

                return array.reduce((total, item) => {
                    const valeur = Number(item[key] || 0);
                    return total + valeur;
                }, 0);
            },

            formatMonney(value){
                return currencyFormatMonney(value)

            },

            numbertolettre(chiffre){

                return NumbertoLettre(chiffre)

            },

            btnviewdrop(){

                if(this.viewdrop===true){

                    this.viewdrop=false;

                }else{

                    this.viewdrop=true;

                }



            },


            ExportExcel(type,name, fn, dl) {
                name=name+"_"+currentDateTime()
                var elt = this.$refs.exportable_table;
                ExportExcel(type,name, fn, dl,elt);

            },



            async print4 () {


                let t=this
                let $style=[],$scripts=[];

                let options = {  name: '_blank', }


                if (this.taillemodel==="A4landscape" || this.taillemodel==="A5landscape" ){

                    $style= [
                        process.env.VUE_APP_URL+'print/bootstrap.min.css',
                        process.env.VUE_APP_URL+'print/stylelandscape1.css',
                        process.env.VUE_APP_URL+'print/stylelandscape.css'
                    ]


                }

                if (this.taillemodel==="A4" || this.taillemodel==="A5" ){


                    $style= [
                        //process.env.VUE_APP_URL+'print/bootstrap.min.css',
                       // process.env.VUE_APP_URL+'print/styleportrait.css',
                        // process.env.VUE_APP_URL+'print/custom_print_a4.css',

                        process.env.VUE_APP_URL+'print/prindefault.css',
                        //process.env.VUE_APP_URL+'assets/css/style.css',

                    ];

                    $scripts= [

                        "https://cdn.tailwindcss.com",
                        //process.env.VUE_APP_URL+'assets/css/style.css',
                    ];

                }

                const printContent = this.$refs.printdoc.innerHTML;
                impression(printContent,$style,window.document.title,$scripts,{ format: this.taillemodel })

            },



            formatMoney(value){
                return currencyFormatDE(value)

            },


            formatnumber(value){
                return FormatNumber(value)

            },



            returnFloatconvert(value){

                //console.log('value ',value)

                let mval= parseFloat(value)

                return mval.toFixed(4)
            },

            close(){

                this.isdisplay=false;

                this.$emit('closed');

            },


            calculSomme(p1,p2,p3){

                var number=parseFloat(p1)+parseFloat(p2)+parseFloat(p3)
                return currencyFormatDE(number)
            },
            calculMonnaie(p1,p2){
                var number=parseFloat(p2)-parseFloat(p1)

                return currencyFormatDE(number)
            },


            currencyFormatDE(p1){
                var number=Number(p1)
                return currencyFormatDE(number)
            },


            async show(titlemodal,numpidcaisse,datedouverture,typedoc,isNormalisationEtat=false){


                this.titlemodal=titlemodal
                this.typedoc=typedoc
                this.isNormalisationEtat=isNormalisationEtat


                /*this.numpidcaisse=numpidcaisse
                this.datedebut=(datedouverture!=="")?datedouverture:this.$store.state.appserverdate
                this.datefin=(datedouverture!=="")?datedouverture:this.$store.state.appserverdate*/

                if (datedouverture!==""){

                    this.viewperiode=false;
                    this.datejournee=datedouverture
                    this.datedebut=datedouverture
                    this.datefin=datedouverture
                    this.numpidcaisse=numpidcaisse

                    this.refresh()

                }else{

                    this.viewperiode=true;
                    this.datedebut=currentDate()
                    this.datefin=currentDate()
                    this.numpidcaisse=numpidcaisse

                }

                this.isdisplay=true;
            },


            async refresh(){
                this.datefin=this.datedebut
                if (!isValidDateString(this.datedebut) || !isValidDateString(this.datefin)){return }

                // '/caisse/c/rapportpointc/:datedebut/:datefin/:pidcaisse/:keyuser/rapportdecaisse/:ftoken'

                this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=`${process.env.VUE_APP_API_URL}/caisse/c/rapportpointc/${this.datedebut}/${this.datefin}/${this.numpidcaisse}/${this.$store.state.appsociete}/rapportdecaisse/${randomString()}`;
                 //url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/c/rapport/component5/etatc/FVC/'+this.datedebut+'/'+this.datefin+'/'+this.numpidcaisse+'/'+this.$store.state.appsociete+'/8954fddpap18rapportcaisse519151911515/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)
                       // t.datatable=[];

                        if(res.data.success){

                            console.log("res.data.m ******** ",res.data.m)


                            //t.datatable=res.data.m


                            //t.isdisplay=true;

                        }
                        else{
                            //t.datatable=[];


                        }

                        t.datatable=res.data.m


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })













            },


            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:92vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1200px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    .ti-btn-success-full {
        background-color: rgb(var(--success));
        --tw-text-opacity: 1;
        color: rgb(255 255 255 / var(--tw-text-opacity));
    }

    .table td {
        cursor: pointer;
    }

    .h-screen{

        height: 300px!important;

    }

    .mybodyheight200px{
        height: 200px;
    }

    .mybodyheight300px{
        height: 300px;
    }

    .mybodyheight400px{
        height: 400px;
    }

    .mybodyheight500px{
        height: 500px;
    }

    @media screen and (max-width: 768px) {

        .cf-dialog--xxl { max-width:100%; }


        .h-screen,.mybodyheight200px,.mybodyheight300px, .mybodyheight400px,.mybodyheight500px{
            height: 100%!important;
        }


    }

</style>